<template>
  <div class="view-all-offer-card-root">
    <div class="offerCard ml12">
      <div :style="getOfferComponentStyle">
        <div class="view-all-offer-card-header">
          <img :src="this.dataViewAllImage" alt="view-all-image" />
        </div>
        <div
          class="d-flex justify-content-center view-all-offer-card-footer"
          @click="handleViewAllOffers"
        >
          <span>{{ dataViewAllText }} </span
          ><span><i class="hkfi-arrow-line pl5 rotate90clockwise"></i> </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Utility from "../helpers/utility";
export default {
  name: "ViewAllOfferCard",
  props: ["dataViewAllImage", "dataViewAllText", "dataViewAllBg"],
  methods: {
    handleViewAllOffers() {
      Utility.sendToOffersScreen();
    },
  },
  computed: {
    getOfferComponentStyle() {
      return {
        background: `url(${this.dataViewAllBg})`,
        backgroundRepeat: `no-repeat`,
        backgroundSize: `100% 100%`,
        padding: "10px",
        height: "88%",
        boxSizing: "border-box",
      };
    },
  },
};
</script>
